import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
// import { colors, typography } from '../../styles';

const styles = css`
  .SitePlanLinks_list {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media(min-width:768px) {
      flex-direction: row;
    }
  }
  .SitePlanLinks_listItem {
    margin: 0 0 60px 0;
    @media(min-width:768px) {
      margin: 0 0 0 0;
    }
  }
  .LinkCard_routeWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .LinkCard_title {
    text-transform: uppercase;
    font-weight: 300;
    font-size: 20px;
    letter-spacing: 1.3px;
    @media(min-width: 768px){
      font-size: 26px;
    }
    @media(min-width: 992px){
      font-size: 34px;
    }
  }
  .Hollow {
    @media(min-width:992px) {
      font-size: 22px;
    }
  }


`;


function SitePlanLinks({ page }) {
  return (
    <div className={styles}>
      <ul className="row list-unstyled">
        {
          page.map(sitePlan => (
            <li className="SitePlanLinks_listItem col-12 col-md-6 col-lg-6" key={sitePlan._id}>
              {
                get(sitePlan, 'button', []).map((item, i) => (
                  <div className="SitePlanLinks_linkCard" key={i.toString()}>
                    <a className="LinkCard_routeWrapper" href={get(item, 'internal_route')}>
                      <h5 className="LinkCard_title">{get(item, 'title')}</h5>
                      <Image
                        className="LinkCard_image my-2"
                        src={get(item, 'image.contentUrl')}
                        alt={get(item, 'title')}
                        width={400}
                        height={300}
                      />
                      <div className="Hollow px-3">
                        {get(item, 'button_text')}
                      </div>
                    </a>
                  </div>
                ))
              }
            </li>
          ))
        }
      </ul>
    </div>
  );
}

SitePlanLinks.propTypes = {
  page: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default (SitePlanLinks);



// WEBPACK FOOTER //
// ./src/pages/Vision/SitePlanLinks.js